import getEnv from './getEnv'
const LOCAL_API = getEnv('REACT_APP_LOCAL_API')
const CLOUD_API = getEnv('REACT_APP_CLOUD_API')

const getApiRoute = () => {
    const local = new URL(LOCAL_API)
    const cloud = new URL(CLOUD_API)
    return {
        local,
        cloud,
    }
}
export default getApiRoute
